import { render, staticRenderFns } from "./aliMaPay.vue?vue&type=template&id=0ee225cd&scoped=true&"
import script from "./aliMaPay.vue?vue&type=script&lang=js&"
export * from "./aliMaPay.vue?vue&type=script&lang=js&"
import style0 from "./aliMaPay.vue?vue&type=style&index=0&id=0ee225cd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee225cd",
  null
  
)

export default component.exports